export default __webpack_public_path__ + "static/media/astro-page.e87eed75.png";